import { Helmet } from 'react-helmet-async';
import AccountListView from 'src/sections/taikhoan/view/account-list-view';
// sections

// ----------------------------------------------------------------------

export default function AccountListPage() {
  return (
    <>
      <Helmet>
        <title> Quản trị: Tài khoản</title>
      </Helmet>

      <AccountListView />
    </>
  );
}
